module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "footer"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('D465')))]), _vm._v(" "), _c('div', {
    staticClass: "cont about"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6,
      "xs": 12
    }
  }, [_c('a', {
    staticClass: "txt",
    attrs: {
      "href": "javascript: void(0);"
    },
    on: {
      "click": _vm.DialogVisible
    }
  }, [_vm._v(_vm._s(_vm.$t('D462')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "xs": 12
    }
  }, [_c('a', {
    staticClass: "txt",
    attrs: {
      "href": "javascript: void(0);"
    },
    on: {
      "click": _vm.goCat
    }
  }, [_vm._v(_vm._s(_vm.$t('D463')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "xs": 12
    }
  }, [_c('a', {
    staticClass: "txt",
    attrs: {
      "href": "javascript: void(0);"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/privacy')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('D464')))])])], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('D466')))]), _vm._v(" "), _c('div', {
    staticClass: "cont connect"
  }, [_c('div', {
    staticClass: "service-contact"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/index/connect-us.svg')
    }
  }), _vm._v(" "), _c('span', [_vm._v("service@xieco.net")])]), _vm._v(" "), _c('div', {
    staticClass: "service-contact"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/index/telephone.svg')
    }
  }), _vm._v(" "), _c('span', [_vm._v("134 8611 1166")])]), _vm._v(" "), _c('div', {
    staticClass: "service-contact"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/index/qq.svg')
    }
  }), _vm._v(" "), _c('span', [_vm._v("2230259928")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "xs": 24
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('D467')))]), _vm._v(" "), _c('div', {
    staticClass: "cont wx"
  }, [_c('img', {
    staticClass: "qr-code",
    attrs: {
      "src": require('@/assets/index/qrCode1.jpg')
    }
  })])]), _vm._v(" "), (false) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('D468')))]), _vm._v(" "), _c('ul', {
    staticClass: "cont link-list"
  }, _vm._l((_vm.linkList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "link-item",
      on: {
        "clic": function($event) {
          _vm.goLink(item.link)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.name))])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('D350'),
      "visible": _vm.centerDialogVisible,
      "width": "610px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('D351')) + "（" + _vm._s(_vm.$t('_5FF8D4C1679F272E')) + "）")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 8,
        maxRows: 12
      },
      "placeholder": _vm.$t('D352')
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('D191')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('SEARCH_05')))])], 1)], 1)], 1), _vm._v(" "), _c('el-footer', {
    staticClass: "beian"
  }, [_vm._v("© Xieco " + _vm._s(_vm.year) + ". All Rights Reserved. \n    "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/#",
      "target": "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('D414')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e551c42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/index.vue
// module id = 621
// module chunks = 39